import HeadingBlock from './base/heading-block';
export default HeadingBlock.extend({
  type: 'subheading',
  tagName: 'h2'
});